module.exports = __webpack_public_path__ + "static/media/pdf-icon-with-text.510382b1.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/pdf-icon-with-text.svg
// module id = 1622
// module chunks = 1